import { useTranslation } from 'react-i18next'

import './CookieConsent.scss'

export type CookieConsentProps = {
  onAcceptCookies: () => void
  onDeclineCookies: () => void
}
export const CookieConsent = ({ onAcceptCookies, onDeclineCookies }: CookieConsentProps) => {
  const { t } = useTranslation('CookieConsent')
  return (
    <div className="CookieConsent">
      <div className="CookieConsent-Title">{t('Title')}</div>
      <div className="CookieConsent-Description">{t('Description')}</div>
      <div className="CookieConsent-Footer">
        <button className="CookieConsent-DeclineButton" onClick={onDeclineCookies}>
          {t('DeclineButtonLabel')}
        </button>
        <button className="CookieConsent-AcceptButton" onClick={onAcceptCookies}>
          {t('AgreeButtonLabel')}
        </button>
      </div>
    </div>
  )
}
